import apiClient from '../config/api';

const tenantService = {
  /**
   * Register a new tenant
   * @param {object} registrationData - Tenant registration data
   * @returns {Promise} Registration response with tenantId
   */
  registerTenant: async (registrationData) => {
    const response = await apiClient.post('/tenant/register', registrationData);
    return response.data;
  },

  /**
   * Check if tenant code is available
   * @param {string} tenantCode - Tenant code to check
   * @returns {Promise} Availability status
   */
  checkTenantAvailability: async (tenantCode) => {
    const response = await apiClient.get(`/tenant/check-availability/${tenantCode}`);
    return response.data;
  },

  /**
   * Get next auto-generated tenant code
   * @returns {Promise} Next tenant code
   */
  getNextTenantCode: async () => {
    const response = await apiClient.get('/tenant/next-code');
    return response.data;
  },

  /**
   * Get tenant information
   * @param {number} tenantId - Tenant ID
   * @returns {Promise} Tenant information
   */
  getTenant: async (tenantId) => {
    const response = await apiClient.get(`/tenant/${tenantId}`);
    return response.data;
  },

  /**
   * Update tenant information
   * @param {number} tenantId - Tenant ID
   * @param {object} updateData - Tenant update data
   * @returns {Promise} Updated tenant information
   */
  updateTenant: async (tenantId, updateData) => {
    const response = await apiClient.post(`/tenant/update/${tenantId}`, updateData);
    return response.data;
  },
};

export default tenantService;

